/**
 * @generated SignedSource<<ca2d6f43195a47099ac5a1f7496c99dd>>
 * @relayHash 9080ca31fb5bdb44cc97bcb74b4f099e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3ca0841fada77c40401477370e014774ed7f5d4e7a2aeae45beef0331884d302

import type { ConcreteRequest } from 'relay-runtime';
export type LegacyAgentVersionPickerWithCapabilityQuery$variables = {
  cloudId: string;
};
export type LegacyAgentVersionPickerWithCapabilityQuery$data = {
  readonly agentStudio_hasVersionCapability: {
    readonly __typename: "AgentStudioHasVersionCapability";
    readonly hasVersionCapability: boolean | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type LegacyAgentVersionPickerWithCapabilityQuery = {
  response: LegacyAgentVersionPickerWithCapabilityQuery$data;
  variables: LegacyAgentVersionPickerWithCapabilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "kind": "LinkedField",
    "name": "agentStudio_hasVersionCapability",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasVersionCapability"
          }
        ],
        "type": "AgentStudioHasVersionCapability"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LegacyAgentVersionPickerWithCapabilityQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LegacyAgentVersionPickerWithCapabilityQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3ca0841fada77c40401477370e014774ed7f5d4e7a2aeae45beef0331884d302",
    "metadata": {},
    "name": "LegacyAgentVersionPickerWithCapabilityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5826a94e8fbd05b6add121e789c65883";

export default node;
